import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { VNode } from 'vue'
import { FormFieldDto, ResourceListDto } from '@/service-proxies/app-v2/dnc.service-proxies'
import { BaseTable } from '@/mixins/Base'
import Ellipsis from '@/components/Ellipsis/index'
import dayjs from 'dayjs'

@Component({
  Ellipsis
})
export default class ResourceTable extends BaseTable<ResourceListDto> {
  @Prop() columns

  selectedRowKeys = []
  selectedIds = []

  onSelectChange(selectedRowKeys, selectedRows) {
    this.selectedRowKeys = selectedRowKeys
    this.selectedIds = selectedRows.map(item => item.id)
    if (this.selectedIds.length > 0) {
      this.$emit('select', true)
    } else {
      this.$emit('select', false)
    }
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  }

  cancelChooseArr(val) {
    this.selectedRowKeys = [];
    this.selectedIds = [];
  }

  render(): VNode {
    const columns = [
      {
        title: this.$t('page_resource_pool_action'),
        key: 'action',
        width: 160,
        customRender: (_, record) => {
          return (
            record.id && 
            <div>
              <a v-acl={'page_resource_pool_edit'} onClick={() => this.$emit('act', { type: 'edit', payload: record })}>
                {this.$t('edit')}
              </a>
              <a-divider type="vertical" />

              <a-popconfirm
                title={this.$t('page_resource_pool_confirm_delete')}
                onConfirm={() => this.$emit('act', { type: 'delete', payload: record })}
                okText={this.$t('yes')}
                cancelText={this.$t('no')}
              >
                <a class="del-color" v-acl={'page_resource_pool_delete'}>{this.$t('delete')}</a>
              </a-popconfirm>
            </div>
          )
        }
      },
      ...this.columns.map(col => {
        if (col.widget === 'SWITCH') {
          return {
            title: col.title,
            dataIndex: col.dataIndex,
            key: col.dataIndex,
            width: 200,
            ellipsis: true,
            customRender: val => (val ? this.$t('yes') : this.$t('no'))
          }
        } else if (col.widget === 'DATE') {
          return {
            title: col.title,
            dataIndex: col.dataIndex,
            key: col.dataIndex,
            width: 180,
            ellipsis: true,
            customRender: text => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        } else {
          return { title: col.title, dataIndex: col.dataIndex, key: col.dataIndex, width: 200, ellipsis: true }
        }
      }),
      {
        title: this.$t('page_resource_pool_status'),
        dataIndex: 'state',
        key: 'state',
        customRender: (value,record) => {
          if(record.id) {
            if (value === 'PUBLISHED') {
              return <a-badge color="green" text={this.$t('page_resource_pool_is_publish')} />
            }
            if (value === 'DRAFTED') {
              return <a-badge color="yellow" text={this.$t('page_resource_pool_drafted')} />
            }
            return <a-badge color="red" text={this.$t('page_resource_pool_not_publish')} />
          }
        },
        filters: [
          {
            text: this.$t('page_resource_pool_is_publish'),
            value: 'PUBLISHED'
          },
          {
            text: this.$t('page_resource_pool_drafted'),
            value: 'DRAFTED'
          },
          {
            text: this.$t('page_resource_pool_not_publish'),
            value: 'INITIAL'
          }
        ],
        onFilter: (value, record) => record.state.indexOf(value) === 0
      }
    ]
    return (
      <ml-table
        size="small"
        columns={columns}
        dataSource={this.data}
        loading={this.loading}
        rowKey="code"
        rowSelection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange,getCheckboxProps: this.getCheckboxProps }}
        canChangeColWidth={true}
        scroll={{ x: (columns.length > 5 ? true : false), y: 630 }}
        chooseArr={this.selectedRowKeys}
        onCancelChooseArr={this.cancelChooseArr}
      ></ml-table>
    )
  }
}
